module.exports = {
          srcSet: __webpack_public_path__ + "b7c71f76.jpg"+" 700w"+","+__webpack_public_path__ + "a7ddc37d.jpg"+" 1290w",
          images:[ {path: __webpack_public_path__ + "b7c71f76.jpg",width: 700,height: 385},{path: __webpack_public_path__ + "a7ddc37d.jpg",width: 1290,height: 710}],
          src: __webpack_public_path__ + "b7c71f76.jpg",
          toString:function(){return __webpack_public_path__ + "b7c71f76.jpg"},
          
          width: 700,
          height: 385
        }